import { useRef, useState,useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";

interface DeliveryCashSearchProps {
  setLoading: (loading: boolean) => void;
  onSearch: (payload: any) => void;
   onReset: () => void;
}

interface UserOption {
  userID: number;
  name: string;
  primaryContactNbr: string;
  displayText: string;
}

const DeliveryCashSearch: React.FC<DeliveryCashSearchProps> = ({ setLoading, onSearch,onReset }) => {
  const toast = useRef<Toast>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  
const [users, setUsers] = useState<UserOption[]>([]);
const [selectedUser, setSelectedUser] = useState<UserOption   | null>(null);

useEffect(() => {
    const fetchUsers = async () => {
      try {
        const userList: UserOption[] = await DeliveryCashService.GetuserlistSearch();

        const mappedUsers = userList.map((user) => ({
          ...user,
          displayText: `${user.name} - ${user.primaryContactNbr}`,
        }));

        setUsers(mappedUsers);
      } catch (error) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load users.",
        });
      }
    };

    fetchUsers();
  }, []);

  const formatToSQLDateTime = (date: Date) =>
    date.toLocaleString("sv-SE").replace(" ", "T");

  const handleSearch = () => {
    if (!startDate || !endDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select both Start Date and End Date.",
      });
      return;
    }

    const adjustedStartDate = new Date(startDate);
    adjustedStartDate.setHours(0, 0, 0, 0);
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);
    const payload = {
      startDate: formatToSQLDateTime(adjustedStartDate),
      endDate: formatToSQLDateTime(adjustedEndDate),

       userId: selectedUser?.userID   
    };

    onSearch(payload);
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedUser(null);
      onReset();
  };

  const selectedUserTemplate = (option: UserOption) => {
    if (option) {
      return (
        <div className="flex flex-col">
          {option.name} - {option.primaryContactNbr}
        </div>
      );
    }
    return <span>Select User</span>;
  };

  const userOptionTemplate = (option: UserOption) => {
    return (
      <div className="flex flex-col">
        {option.name} - {option.primaryContactNbr}
      </div>
    );
  };

  return (
    <div className="card border-noround p-3 w-full">
      <Toast ref={toast} />

      <div className="grid">

         <div className="col-12 md:col-3">
          <Dropdown
            value={selectedUser}
            onChange={(e: DropdownChangeEvent) => setSelectedUser(e.value)}
            options={users}
            optionLabel="displayText"
            placeholder="Select User"
            filter
            filterBy="displayText"
            filterMatchMode="contains"
            valueTemplate={selectedUserTemplate}
            itemTemplate={userOptionTemplate}
            className="w-full"
          />
        </div>

        <div className="col-6 md:col-2">
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="Start Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-2">
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="End Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-2">
          <Button label="Filter" onClick={handleSearch} severity="success" className="w-full" />
        </div>
        <div className="col-6 md:col-2">
          <Button label="Reset" onClick={handleReset} severity="secondary" className="w-full" text raised />
        </div>
        
      </div>
    </div>
  );
};

export default DeliveryCashSearch;
